// @flow

import type { UrlPattern } from './contracts';

export type RouteFilter = {
	partName: string,
	predicate: (string) => boolean,
}

export class Route {
	_name: string;
	_urlPattern: UrlPattern;
	_callback: Function;
	_filters: ?Array<RouteFilter>;

	/**
	 * @param {string} name - The route name. It has to be unique compared to all the other routes
	 * @param {UrlPattern} urlPattern - Url template. Example: /tabs/:tabName/:page
	 * @param {function} callback - The route callback that will receive the query string parameters
	 * @param {[]} filters - Example: [{ 'page', page => parseInt(page) >= 1 }]
	 */
	constructor (
		name: string,
		urlPattern: UrlPattern,
		callback: Function,
		filters: ?Array<RouteFilter>,
	){
		this._name = name;
		this._urlPattern = urlPattern;
		this._callback = callback;
		this._filters = filters;
	}

	/**
	 * The route name.
	 * Used for generating links (hashes) for named route (method Router.url()).
	 * @return {string} - Url hash
	 */
	get name (): string {
		return this._name;
	}

	get urlPattern (): UrlPattern {
		return this._urlPattern;
	}

	get callback (): Function {
		return this._callback;
	}

	get filters (): ?Array<RouteFilter> {
		return this._filters;
	}
}
